import { IssueResponseDto, useApi } from '@issuemanager/api-client';
import { ExtendedAxiosError } from '@issuemanager/apps/client/hooks';
import { useMutation, useQueryClient } from '@tanstack/react-query';

type UseSubmitToInReviewParams = {
  code: string;
  onSuccess?: () => void;
  onError?: (error: ExtendedAxiosError) => void;
};

export function useSubmitToInReview({
  code,
  onSuccess,
  onError,
}: UseSubmitToInReviewParams) {
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation<IssueResponseDto, ExtendedAxiosError, void>({
    mutationKey: ['issues', code],
    mutationFn: () => api.issuesApi.moveIssueToOpen(code).then((r) => r.data),
    onSuccess: async (response) => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: ['users', 'roles'],
        }),
        queryClient.invalidateQueries({
          queryKey: ['user-roles', code],
        }),
      ]);
      queryClient.setQueryData<IssueResponseDto>(['issues', code], response);
      onSuccess?.();
    },
    onError,
  });
}
